import { render, staticRenderFns } from "./netCelebritySJ.vue?vue&type=template&id=0da02059&scoped=true"
import script from "./netCelebritySJ.vue?vue&type=script&lang=js"
export * from "./netCelebritySJ.vue?vue&type=script&lang=js"
import style0 from "./netCelebritySJ.vue?vue&type=style&index=0&id=0da02059&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da02059",
  null
  
)

export default component.exports